import { Text, View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { parseTimeFrame } from '@/utils/dater';

/**
 * TouchSummaryCards — last personal attempt / last connected / 30-day
 * counts. Displays recency from occurredAt (server-computed), never from
 * row insertion time.
 */
const TouchSummaryCards = ({ person }) => {
    const lastAttempt = person?.lastPersonalAttemptAt;
    const lastConnected = person?.lastConnectedAt;
    const attempts30d = person?.counts?.attempts30d ?? 0;
    const connected30d = person?.counts?.connected30d ?? 0;

    return (
        <View style={styles.row} testID="follow-up-summary-cards">
            <View style={styles.card}>
                <Text style={styles.label}>Last Attempt</Text>
                <Text style={styles.value}>{lastAttempt ? parseTimeFrame(lastAttempt) : '—'}</Text>
            </View>
            <View style={styles.card}>
                <Text style={styles.label}>Last Connected</Text>
                <Text style={[styles.value, lastConnected && styles.connectedValue]}>
                    {lastConnected ? parseTimeFrame(lastConnected) : '—'}
                </Text>
            </View>
            <View style={styles.card}>
                <Text style={styles.label}>Last 30 Days</Text>
                <Text style={styles.value}>
                    {attempts30d} attempt{attempts30d === 1 ? '' : 's'} · {connected30d} connected
                </Text>
            </View>
        </View>
    );
};

const styles = StyleSheet.create(({ colors, fonts, shadows }) => ({
    row: { flexDirection: 'row', gap: 8 },
    card: {
        flex: 1,
        backgroundColor: colors.surface,
        borderRadius: 12,
        padding: 12,
        boxShadow: shadows.card,
    },
    label: { fontSize: 11, color: colors.textSecondary, fontFamily: fonts.medium },
    value: { fontSize: 13, color: colors.text, fontFamily: fonts.bold, marginTop: 4 },
    connectedValue: { color: colors.success },
}));

export default TouchSummaryCards;
